module.exports = "/images/clubspeed.svg?fc197c820d63379f4bc283e25f5ed871";